import React, { FC, useEffect, useRef, useState } from 'react'
import { CountDownStyles } from '../style'

type CountDownProps = {
  headerData: {
    clockIntro: string
    days: string
    hours: string
    minutes: string
    seconds: string
    newEndDate: string
    length: string
  }
}

export const CountDown: FC<CountDownProps> = ({ headerData }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: '',
    hours: '',
    minutes: '',
    seconds: '',
  })

  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (!headerData.newEndDate) return

    const targetTimeGMT = new Date(headerData.newEndDate).getTime()

    const calculateTimeLeft = () => {
      const now = Date.now()
      const diff = targetTimeGMT - now

      if (diff <= 0) {
        document.querySelectorAll('.butterBar__link').forEach(el => el.remove())
        setTimeLeft({ days: '00', hours: '00', minutes: '00', seconds: '00' })
        if (timerRef.current) clearInterval(timerRef.current)
        return
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)

      if (headerData.length.includes('Hours') || days < 3) {
        const totalHours = Math.floor(diff / (1000 * 60 * 60))
        setTimeLeft({
          days: '00',
          hours: String(totalHours).padStart(2, '0'),
          minutes: String(minutes).padStart(2, '0'),
          seconds: String(seconds).padStart(2, '0'),
        })
      } else {
        setTimeLeft({
          days: String(days).padStart(2, '0'),
          hours: String(hours).padStart(2, '0'),
          minutes: String(minutes).padStart(2, '0'),
          seconds: '00',
        })
      }
    }

    calculateTimeLeft()
    timerRef.current = setInterval(calculateTimeLeft, 1000)

    return () => {
      if (timerRef.current) clearInterval(timerRef.current)
    }
  }, [headerData?.newEndDate])

  return (
    <CountDownStyles>
      <div className="countDownClock">
        <span className="clockIntro">{headerData.clockIntro}</span>
        {timeLeft.days !== '00' && (
          <span className="countText activeCount">
            <span>{timeLeft.days}</span>
            <sup>{headerData.days}</sup>
          </span>
        )}
        <span className={`countText ${timeLeft.days === '00' ? 'activeCount' : ''}`}>
          <span>{timeLeft.hours}</span>
          <sup>{headerData.hours}</sup>
        </span>
        <span className="countText">
          <span>{timeLeft.minutes}</span>
          <sup>{headerData.minutes}</sup>
        </span>
        {timeLeft.days === '00' && (
          <span className="countText">
            <span>{timeLeft.seconds}</span>
            <sup>{headerData.seconds}</sup>
          </span>
        )}
      </div>
    </CountDownStyles>
  )
}
